// extracted by mini-css-extract-plugin
module.exports = {"footprintStyle":"FootprintButton--footprintStyle--Yn6II","disabled":"FootprintButton--disabled--2azYj","dark":"FootprintButton--dark--FM2JN"};